// @noflow
export function getDirtyFields(arr) {
    return getItemsWithProp(arr, 'dirty');
}

export function getItemsWithProp(arr, prop) {
    return arr.filter(item => {
        const values = Object.values(item);
        return values.some(key => key[prop]);
    });
}

/* eslint-disable no-unused-vars */
// React 15.3 gives a warning about unknown props being passed to a component.
// Since Redux Form V5 just gives us a big object of props we need to extract
// just the ones for an <input />.
export function getDOMOnlyProps({
    active,
    autofill,
    autofilled,
    dirty,
    error,
    initialValue,
    invalid,
    onUpdate,
    pristine,
    touched,
    valid,
    visited,
    ...domProps
}) {
    return domProps;
}
/* eslint-enable no-unused-vars */



// WEBPACK FOOTER //
// ./src/core/utils/form/form-helpers.js